import React from 'react';
import { EllipsisDot, StyledEllipsis } from './style';

const Loader = ({ loadExportInfo }) => {
  return (
    <StyledEllipsis style={{ height: loadExportInfo && 0, marginLeft: loadExportInfo && 32 }}>
      <EllipsisDot color='var(--loader-Ellipsis-dot1-color)' />
      <EllipsisDot color='var(--loader-Ellipsis-dot2-color)' />
      <EllipsisDot color='var(--loader-Ellipsis-dot3-color)' />
      <EllipsisDot color='var(--loader-Ellipsis-dot4-color)' />
    </StyledEllipsis>
  );
};

export default Loader;
